var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragableSixDots = function SvgDragableSixDots(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D8",
    d: "M5 4.001a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333ZM5 8.668a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333ZM5 13.335A.667.667 0 1 1 5 12a.667.667 0 0 1 0 1.334ZM11 4.001a.667.667 0 1 1 0-1.333A.667.667 0 0 1 11 4ZM11 8.668a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333ZM11 13.335A.667.667 0 1 1 11 12a.667.667 0 0 1 0 1.334Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4D4D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5 4.001a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333ZM5 8.668a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333ZM5 13.335A.667.667 0 1 1 5 12a.667.667 0 0 1 0 1.334ZM11 4.001a.667.667 0 1 1 0-1.333A.667.667 0 0 1 11 4ZM11 8.668a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333ZM11 13.335A.667.667 0 1 1 11 12a.667.667 0 0 1 0 1.334Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragableSixDots);
export default ForwardRef;